export const loadMetadata = async (
  src: string
): Promise<{
  data: number[]
} | null> => {
  try {
    const response = await fetch(src)
    const data = await response.json()
    return data
  } catch (error) {
    console.error("Error fetching metadata:", error)
    return null
  }
}

export const parseTimestamp = (timestamp: string): number => {
  const [minutes, seconds] = timestamp.split(":")
  return parseInt(minutes) * 60 + parseInt(seconds)
}
